import { Flex, HStack, Text } from '@chakra-ui/react'
import { faCheck, faEllipsisV, faXmark } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { ReactElement } from 'react'

import type { UserCardUserFragment } from '@/client/services/hasura/generated/graphql'

import Icon from '@/components/UI/Icon/Icon'
import Tippy from '@/components/UI/Tippy'
import Avatar from '@/components/Worlds/UI/Avatar/Avatar'
import Card from '@/components/Worlds/UI/Card'
import Menu from '@/components/Worlds/UI/Menu/Menu'
import type { MenuItemType } from '@/components/Worlds/UI/Menu/types'

export default function UserCard({
  user,
  attemptedJoining,
  menuItems,
}: {
  user: UserCardUserFragment
  attemptedJoining: boolean
  menuItems: MenuItemType[][]
}): ReactElement {
  return (
    <Card width="100%" px={2} py={2}>
      <Flex justify="space-between" align="center">
        <HStack>
          <Avatar size="sm" user={user} />
          <Text>{user.virtual_display_name}</Text>
        </HStack>
        <HStack>
          {attemptedJoining ? (
            <Tippy content="This user has attempted to join this session, but may have left.">
              <Text color="fg.success">
                <FontAwesomeIcon icon={faCheck} />
              </Text>
            </Tippy>
          ) : (
            <Tippy content="This user has not attempted to join this session yet.">
              <Text color="fg.error">
                <FontAwesomeIcon icon={faXmark} />
              </Text>
            </Tippy>
          )}
          <Menu
            buttonProps={{
              'aria-label': 'More options',
              icon: <Icon faIcon={faEllipsisV} size="sm" color="fg.muted" />,
            }}
            itemGroups={menuItems}
          />
        </HStack>
      </Flex>
    </Card>
  )
}
